import React from 'react'
import LocationReportChart from './locationReportChart/LocationReportChart'
import LocationReportList from './locationReportChart/LocationReportList'

const LocationReportCard = () => {
    return (
        <div className='w-full h-full text-sm font-color-4 flex flex-col'>
            <div className='flex justify-between items-center'>
                <p>Niederlassungsauswertung</p>
                <button
                    className='hidden ml-4 px-3 py-2 bg-color-5 font-color-1 text-sm flex items-center shadow-sm border border-color-2 rounded-lg font-medium'>
                    Report anzeigen
                </button>
            </div>
            <div className='flex items-center'>
                <div className='font-color-6 mt-10'>Niederlassungen im Vergleich</div>
            </div>
            <div className='mt-12 flex justify-center items-center w-full h-36 my-4'>
                <LocationReportChart/>
            </div>
            <div className='mt-12'>
                <p className='font-color-6'>Standorte</p>
                <LocationReportList/>
            </div>
        </div>

    )
}

export default LocationReportCard